import { EnvironmentFile } from '@interfaces';
import { Environment } from '@enums';

export const ENV: EnvironmentFile = {
  production: false,
  name: Environment.DEV,
  MTY_SICOP: 'https://qa.sicopweb.com',
  MTY_SICOP_QA: 'https://qa.sicopweb.com',
  GOOGLE_SEEKOP_IO: 'http://localhost:8080',
  AUTH_API_BASE_URL: '',
  ORBIT_AUTH_API_BASE_URL: 'https://mkt.sicopweb.com',
  IA_AGENTS_API_BASE_URL: 'https://ia-dev.sicopweb.net',
  AUTH_REFRESH_THRESHOLD_SECONDS: 120,
  D7WI0B: {
    I9PAIC: 'E4cDiqGZYSNC5IYok-Yn5BS-gQPTAbxrq5_DQhynpgxsJObmYXFQ1ciVKVz',
    JSICWV: 'iM34g-07Xciaqkj0W-r3ue539lHBNWeoJLVKmyruRiolt3r9qbbJ-oVSprR8',
    WOV6N5: 'dWpaYP2fJ-mEXYkGoai-',
    AETDL1: 'dXnyvWnHepYRjYKf3eRE',
    ZNPAXD: 'YmhiCEy091',
    GDI83Q: 'm3t3n3WpzTJI_5bJANzcud4HOcS5',
  },
};
